import { formatCurrency } from "@ashirbad/js-core";
import MaterialTable from "@material-table/core";
import { NavigateNext } from "@mui/icons-material";
import {
  Avatar,
  Button,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useIsMounted } from "hooks";
import { useOrdersData } from "hooks/useDataFetch";
import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { muiTable } from "utils";

const ManageOrders = () => {
  const [orderType, setOrderType] = useState("all");
  const [orderDetails, setOrderDetails] = useState([]);
  const [filteredOrderDetails, setFilteredOrderDetails] = useState([]);

  const isMounted = useIsMounted();

  const orderData = useOrdersData();

  const navigate = useNavigate();

  // console.log(orderData);

  useEffect(() => {
    if (isMounted.current) {
      if (!orderData?.data) return;

      let orderArray = [];
      let sl = 1;

      let sortedData = orderData?.data.sort((a, b) => {
        return b.createdAt - a.createdAt;
      });

      sortedData?.map((order) => {
        return order?.products?.map((product) => {
          orderArray.push({
            ...order,
            orderId: order.id,
            id: order.id + "-" + sl,
            products: product,
            sl,
          });
          sl++;
          return null;
        });
      });

      setOrderDetails(orderArray);
    }
  }, [isMounted, orderData?.data]);

  useEffect(() => {
    if (isMounted.current) {
      if (!orderDetails) return;
      if (orderType === "all") {
        setFilteredOrderDetails(orderDetails);
        return;
      } else if (orderType === "pending") {
        setFilteredOrderDetails(
          orderDetails.filter((order) => order.status === "pending")
        );
        return;
      } else if (orderType === "delivered") {
        setFilteredOrderDetails(
          orderDetails.filter((order) => order.status === "delivered")
        );
        return;
      } else if (orderType === "cancelled") {
        setFilteredOrderDetails(
          orderDetails.filter((order) => order.status === "cancelled")
        );
        return;
      }
    }
  }, [isMounted, orderType, orderDetails]);

  // console.log(orderDetails);
  return (
    <section className="manage-order-main-section">
      <div className="manage-order-filter-bar flex-row align-items-center justify-content-between  ">
        <div className="manage-order-title">Manage Orders</div>
        <div className="flex-column gap-2 manage-select ">
          <InputLabel id="order-type-select">Select Order Type</InputLabel>
          <Select
            labelId="order-type-select"
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
          >
            <MenuItem value="all">All Orders</MenuItem>
            <MenuItem value="delivered">Order Delivered</MenuItem>
            <MenuItem value="pending">Order Pending</MenuItem>
            <MenuItem value="cancelled">Order Cancelled</MenuItem>
          </Select>
        </div>
      </div>
      <div className="w-100">
        <MaterialTable
          title="Suppliers"
          isLoading={!filteredOrderDetails && orderData?.loading}
          data={filteredOrderDetails || []}
          options={{ ...muiTable.options() }}
          style={muiTable.styles}
          columns={[
            {
              title: "#",
              field: "sl",
              width: "5%",
              editable: "never",
              id: "sl",
              key: "sl",
            },
            {
              title: "Customer",
              field: "userName",
              emptyValue: "No value  ",
            },
            {
              title: "Product",
              field: "products",
              render: (rowData) => {
                return (
                  <Avatar
                    sx={{
                      height: "4rem",
                      width: "4rem",
                      borderRadius: "7px",
                    }}
                    src={rowData?.products?.productImg}
                  />
                );
              },
            },
            {
              title: "Item",
              field: "products.orderedQty",
              emptyValue: "No value  ",
              render: (rowData) => {
                return (
                  <Typography>
                    {rowData?.products?.orderedQty} Piece{" "}
                  </Typography>
                );
              },
            },
            {
              title: "Price",
              field: "products.price",
              emptyValue: "No value  ",
              render: (rowData) => {
                return formatCurrency(rowData?.products?.price, "SAR");
              },
            },
            {
              title: "Payments Status",
              field: "paymentStatus",
              emptyValue: "Not Updated  ",
              render: (rowData) => {
                return (
                  <Typography
                    sx={{
                      color: "#ffffff",
                      textTransform: "uppercase",
                      backgroundColor:
                        rowData?.paymentStatus === "paid"
                          ? "#00b712"
                          : "#727272",
                      padding: " 0.2rem 1rem",
                      borderRadius: "1rem",
                      width: "fit-content",
                      fontSize: "0.8rem",
                    }}
                  >
                    {rowData?.paymentStatus}
                  </Typography>
                );
              },
            },
            {
              title: "Order Status",
              field: "status",
              emptyValue: "Not Updated  ",
              render: (rowData) => {
                return (
                  <Typography
                    sx={{
                      color: "#ffffff",
                      textTransform: "uppercase",
                      backgroundColor:
                        rowData?.status === "delivered"
                          ? "#00b712"
                          : rowData?.status === "shipped"
                          ? "#e3c224"
                          : rowData?.status === "failed"
                          ? "#e32424"
                          : "#727272",
                      padding: " 0.2rem 1rem",
                      borderRadius: "1rem",
                      width: "fit-content",
                      fontSize: "0.8rem",
                    }}
                  >
                    {rowData?.status}
                  </Typography>
                );
              },
            },
            {
              title: "Date",
              field: "createdAt",
              type: "date",
              render: (rowData) => {
                return moment(rowData?.createdAt).fromNow();
              },
            },

            {
              title: "Actions",
              render: (rowData) => {
                return (
                  <div className="flex-row gap-1">
                    <Button
                      endIcon={<NavigateNext />}
                      onClick={() => {
                        navigate(`/admin/order/${rowData?.orderId}`);
                      }}
                      sx={{
                        backgroundColor: "#a92e74",
                        color: "#ffffff",
                        ":hover": {
                          backgroundColor: "#a92e74",
                        },
                        width: "10rem",
                      }}
                    >
                      Order Details
                    </Button>
                  </div>
                );
              },
            },
          ]}
        />
      </div>
    </section>
  );
};

export default ManageOrders;
